import React, { useState } from "react";
import { BiEnvelope } from "react-icons/bi";
import { AiOutlineBell, AiOutlinePoweroff } from "react-icons/ai";
import { FaRegUser } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Avatar } from "../UI";
import axios from "../../axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export default function Topbar() {
  const user = JSON.parse(localStorage.getItem("user"));
  const fullName = user[0].firstName + " " + user[0].lastName;
  const [profilePic] = useState(user[0].profilePhoto);
  const navigate = useNavigate();

  const handleLogout = () => {
    axios
      .post("/logout", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          localStorage.clear();
          Swal.fire({
            icon: "info",
            title: "Logging out...",
            showConfirmButton: false,
            timer: 1500,
            padding: "2em",
            allowOutsideClick: false,
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              navigate("/login");
            }
          });
        } else {
          toast.warn("No response from server");
        }
      })
      .catch((error) => {
        toast.error("Something went wrong");
        console.log(error);
      });
  };

  return (
    <section className="topbar py-3 pe-lg-0 pe-md-3">
      <div className="container">
        <div className="row g-0">
          <div className="col-md-12">
            <div className="d-flex justify-content-end">
              {/* <Dropdown align='end'>
                            <Dropdown.Toggle variant='topbar-icon corner-radius' className='me-4 px-2'>
                                <BiEnvelope size={30} /><span className='badge'>1</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className='shadow-sm'>
                                <Dropdown.Item href="">Coming Soon!</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown align='end'>
                            <Dropdown.Toggle variant='topbar-icon corner-radius' className='me-4 px-2'>
                                <AiOutlineBell size={30} /><span className='badge'>4</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className='shadow-sm'>
                                <Dropdown.Item href="">Coming Soon!</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown> */}
              <Avatar image={profilePic} />
              <Dropdown align="end">
                <Dropdown.Toggle variant="topbar-menu">
                  <span className="user-name">{fullName} </span>
                  <FiChevronDown size={20} />
                </Dropdown.Toggle>
                <Dropdown.Menu className="user-menu">
                  <Link to="/profile" className="link user-menu-item">
                    <FaRegUser size={20} /> Profile
                  </Link>
                  <div className="link user-menu-item" onClick={handleLogout}>
                    <AiOutlinePoweroff size={20} /> Logout
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
